export default "__VITE_ASSET__BHWsbv3d__"